import { Injectable } from '@angular/core'
import { IFiles } from 'src/interfaces/files/files.interface'

@Injectable({
  providedIn: 'root',
})
export class FilesUtils {
  createFileFormData(files: IFiles[]): FormData {
    const formData = new FormData()
    for (const file of files) {
      const name = this.replaceSpecialCharacters(file.name)
      const newFile = new File([file.file], name, {
        type: file.file.type,
        lastModified: file.file.lastModified,
      })
      const fileName = `${name}-${file.attachmentType}`
      formData.append('files', newFile, fileName)
    }
    return formData
  }

  replaceSpecialCharacters(name: string): string {
    return name.replace('_', '-').replace(/[%_/()]/g, '')
  }
}
